"use client";

import React, { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import CusTitle from "@/components/Home2/CusTitle";
import "animate.css";
import GetQuteTip from "@/components/Service/CNC/GetQuteTip.tsx";
import { Swiper, SwiperSlide } from "swiper/react";
type testimonials = {
	banner: string;
	name: string;
	company: string;
	content: string;
};
const Testimonials = ({
	className,
	tList,
	dsc,
	tip,
}: {
	className?: string;
	tList?: testimonials[];
	dsc?: string;
	tip?: string;
}) => {
	const t = useTranslations();
	const list = [
		{
			banner: "/image/home/customerTestimonials/John Doe.png",
			name: "testimonials.name1",
			company: "testimonials.company1",
			content: "testimonials.t1",
		},
		{
			banner: "/image/home/customerTestimonials/Jane Smith.png",
			name: "testimonials.name2",
			company: "testimonials.company2",
			content: "testimonials.t2",
		},
		{
			banner: "/image/home/customerTestimonials/Michael Brown.png",
			name: "testimonials.name3",
			company: "testimonials.company3",
			content: "testimonials.t3",
		},
	];

	const refs = useRef<(HTMLLIElement | null)[]>([]);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add("animate__animated", "animate__fadeInUp"); // 添加动画类
						observer.unobserve(entry.target); // 动画触发一次后，停止监听
					}
				});
			},
			{ threshold: 0.2 }, // 视图进入 20% 时触发
		);

		refs.current.forEach((ref) => {
			if (ref) {
				observer.observe(ref);
			}
		});

		return () => {
			refs.current.forEach((ref) => {
				if (ref) observer.unobserve(ref);
			});
		};
	}, []);

	return (
		<div className={`${className} mb-4 pt-10 md:mb-14 md:py-10`}>
			<div className="container text-center">
				<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
					{t("testimonials.CustomerTestimonials")}
				</h2>
				<div className="flex justify-center text-center">
					<p className="mb-4 text-sm leading-relaxed text-gray-900 md:text-base">
						{t(dsc || "testimonials.Dicover")}
					</p>
				</div>
				<div
					className="trustpilot-widget mt-10"
					data-locale="en-GB"
					data-template-id="53aa8912dec7e10d38f59f36"
					data-businessunit-id="68808142dd0a4c4d3e411b9c"
					data-style-height="140px"
					data-style-width="100%"
					data-token="641f8116-607b-46db-8dbe-580350245132"
					data-stars="1,2,3,4,5"
					data-review-languages="en"
				>
					<a
						href="https://www.trustpilot.com/review/www.cncprotolabs.com?utm_medium=trustbox&utm_source=MicroTrustScore"
						target="_blank"
						rel="noopener"
					>
						Trustpilot
					</a>
				</div>
				{/* <div
					className="trustpilot-widget mt-10"
					data-locale="en-US"
					data-template-id="53aa8912dec7e10d38f59f36"
					data-businessunit-id="684b98d829d0eb9d793ec2d4"
					data-style-height="140px"
					data-style-width="100%"
					data-stars="1,2,3,4,5"
					data-review-languages="en"
				>
					<a href="https://www.trustpilot.com/review/jsrpm.com" target="_blank" rel="noopener">
						Trustpilot
					</a>
				</div> */}

				{/* <Swiper
					spaceBetween={10}
					slidesPerView={1}
					pagination={{ clickable: true }}
					breakpoints={{
						640: {
							slidesPerView: 1,
						},
						768: {
							slidesPerView: 2,
						},
						1024: {
							slidesPerView: 3,
						},
						1600: {
							slidesPerView: 3,
						},
					}}
					className="animate__animated animate__fadeIn !p-4 !pb-14"
				>
					{(tList || list).map((item, index) => (
						<SwiperSlide
							key={index}
							className={` ${!className ? "bg-[#f7f7f7]" : "bg-white"}  rounded-lg px-4 py-8  `} // 初始状态不可见
						>
							<div className="flex h-full flex-col justify-between">
								<Image
									src="/image/home/customerTestimonials/comma.png"
									alt="icon-comma"
									width={50}
									height={50}
									quality={100}
									className="object-cover"
								/>
								<p className="my-5 text-left text-sm text-gray-900">{t(item.content)}</p>
								<div className="flex gap-x-5">
									<Image
										src={item.banner}
										alt="icon-name"
										width={45}
										height={45}
										quality={100}
										className="rounded-full object-cover"
									/>
									<div className="flex flex-col items-start">
										<div className="text-lg font-bold">{t(item.name)}</div>
										<div className="flex items-center">
											<Image
												src="/image/home/customerTestimonials/company-fill.png"
												alt="icon-company"
												width={20}
												height={20}
												quality={100}
												className="rounded-full object-cover"
											/>
											<div className="text-gray-900">{t(item.company)}</div>
										</div>
									</div>
								</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper> */}
			</div>
			{tip && <GetQuteTip tip={t(tip)}></GetQuteTip>}
		</div>
	);
};

export default Testimonials;
